import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';

interface IProps {
  when: boolean;
  message: string;
}

const PromptMock = ({ when, message }: IProps) => {
  const block = when;

  useEffect(() => {
    if (when)
      window.onbeforeunload = (event: BeforeUnloadEvent) => {
        event.preventDefault();
        return (event.returnValue = message);
      };

    return () => {
      window.onbeforeunload = null;
    };
  }, [when]);

  useBlocker(({ currentLocation, nextLocation }) => {
    const { pathname: currentLocationPathName } = currentLocation;
    const { pathname: nextLocationPathName } = nextLocation;

    const editedCurrentLocationPathname = currentLocationPathName.replace('/ko', '');
    const editedNextLocationPathName = nextLocationPathName.replace('/ko', '');

    if (editedCurrentLocationPathname === editedNextLocationPathName) return false;

    if (block) {
      return !window.confirm(message);
    }

    return false;
  });

  return undefined;
};

export default PromptMock;
